import CommentInputBox from "../../../../components/CommentBox/CommentInputBox";
import Comment from "../../../../components/CommentBox/Comment";
import {useCommunity} from "../../../../redux/Reducers/CommunityComments";
import {useEffect} from "react";
import Filter from "../../../../components/Filter/Filter";
import {LiaBatteryEmptySolid} from "react-icons/lia";


export const CommentFilterData = {
    title: "Sort By",
    options: [
        {
            name: 'Likes',
            value: 'likes'
        },
        {
            name: "Replies",
            value: "replies"
        },
        {
            name: "Newest",
            value: "newest"
        }, {
            name: "Oldest",
            value: "oldest"
        }

    ]
}

export function CommentLoadingAnimation({comments = 6}) {

    return (
        <div className={"animate flex flex-col gap-6 mb-10 animate-pulse"}>
            {
                [...Array(comments)].map((_, i) => (
                    <div key={i} className={"flex flex-row rounded-md gap-2 w-full"}>
                        <div className={"rounded-full w-10 h-10 bg-gray-200"}/>
                        <div className={"flex-col flex flex-1  gap-2"}>
                            <div className={"rounded-lg h-10 lg:h-16 bg-gray-200"}/>
                            <div className={"rounded-lg  h-5 bg-gray-200"}/>

                        </div>
                    </div>
                ))
            }

        </div>
    )
}


export default function UserCommentSection({className, ...props}) {
    const {state, isLoading, actions} = useCommunity();


    useEffect(() => {
        actions.initalLoad();
    }, [])

    return (
        <div className={"mt-10 flex flex-col"}>
            <div className={`mb-4 border-b-[1px] pb-4 ${className}`}>
                <div className={"flex flex-row gap-2"}>
                    <p className={"font-semibold flex-1"}>
                        {state?.count} Comments
                    </p>

                    <div className={"flex gap-2"}>
                        <Filter {...CommentFilterData} defaultValue={state?.sortBy} onChange={(sortBy) => {
                            actions.SortBy(sortBy);
                        }}/>
                    </div>

                </div>
            </div>
            {
                !isLoading && state?.comments?.length === 0 && <div className={"flex flex-col mt-12 gap-2 items-center"}>
                    <LiaBatteryEmptySolid className={"text-4xl"} />

                    <p className={"font-bold text-xl text-center"}>
                        No comments yet
                    </p>
                    <p className={"text-center"}>
                        Be the first to comment
                    </p>
                </div>
            }
            {
                state?.newComments?.map((comment, i) => (
                    <Comment comment={comment} key={comment?.id} deleteComment={()=>actions.deleteComment(comment?.id)}/>
                ))
            }
            {
                state?.comments?.map((comment, i) => (
                    <Comment comment={comment} key={comment?.id} deleteComment={()=>actions.deleteComment(comment?.id)}/>
                ))
            }
            {
                isLoading && <CommentLoadingAnimation/>
            }


            {state?.next && <div onClick={actions.loadMoreComments}
                                 className={"flex-1 gap-3 cursor-pointer mb-4 lg:mb-8 flex justify-center items-center"}>
                <p className={"bg-tertiary-150 h-10 w-10 rounded-full text-center text-2xl text-tertiary-900"}>
                    +
                </p>
                <p className={"text-lg font-bold "}>
                    Load More
                </p>
            </div>}

        </div>

    )
}


